import { RootState } from '../reducers'

export const getProducts = (state: RootState) => state.product.products
export const getIsLoading = (state: RootState) => state.product.isLoading
export const getIsConfirmLoading = (state: RootState) =>
  state.product.isConfirmLoading
export const getProductSelected = (state: RootState) =>
  state.product.productSelected
export const getModalVisibility = (name: string) => (state: RootState) =>
  state.product.modalVisibility[name]?.visible || false

export const getImportTarget = (state: RootState) => state.product.importTarget
export const getIsImporting = (state: RootState) => state.product.isImporting
export const getImportResult = (state: RootState) => state.product.importResult

export const getPermissionGroups = (state: RootState) =>
  state.product.permissionGroups
export const getIsLoadingPermissionGroups = (state: RootState) =>
  state.product.isLoadingPermissionGroups
export const getPermissions = (state: RootState) => state.product.permissions
export const getIsLoadingPermissions = (state: RootState) =>
  state.product.isLoadingPermissions
export const getPermissionsPageMeta = (state: RootState) =>
  state.product.permissionsPageMeta

export const getPermissionSelected = (state: RootState) =>
  state.product.permissionSelected
export const getIsMutatingPermission = (state: RootState) =>
  state.product.isMutatingPermission
export const getPermissionsVersion = (state: RootState) =>
  state.product.permissionsVersion
